/**
 * Location Service
 * Handles location management API calls
 */

import axiosInstance, { apiRequest } from '../axiosInstance';
import { LOCATION_ENDPOINTS, buildQueryString } from '../endpoints';

const locationService = {
  getLocations: async (params = {}) => {
    const queryString = buildQueryString(params);
    return apiRequest(() =>
      axiosInstance.get(`${LOCATION_ENDPOINTS.LIST}${queryString}`)
    );
  },

  getLocationById: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(LOCATION_ENDPOINTS.GET_BY_ID(id))
    );
  },

  createLocation: async (data) => {
    return apiRequest(() =>
      axiosInstance.post(LOCATION_ENDPOINTS.CREATE, data)
    );
  },

  updateLocation: async (id, data) => {
    return apiRequest(() =>
      axiosInstance.put(LOCATION_ENDPOINTS.UPDATE(id), data)
    );
  },

  deleteLocation: async (id) => {
    return apiRequest(() =>
      axiosInstance.delete(LOCATION_ENDPOINTS.DELETE(id))
    );
  },
};

export default locationService;
